import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "./UserContext";
import "./Header.css";

const Header = () => {
  const { user, isAuthenticated, logout } = useContext(UserContext);
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(() => localStorage.getItem("darkMode") === "true");
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navRef = useRef(null);

  useEffect(() => {
    document.body.classList.toggle("dark-mode", isDarkMode);
    localStorage.setItem("darkMode", isDarkMode);
  }, [isDarkMode]);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate("/login");
  };

  const toggleDarkMode = () => setIsDarkMode((prevMode) => !prevMode);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuOpen]);

  return (
    <header className="site-header" ref={navRef}>
      <nav className="nav">
        {/* Logo */}
        <Link to="/" className="logo-container" onClick={closeMenu}>
          <img src="/images/wf_logo.png" alt="Wholeness Forward Logo" className="logo" />
        </Link>

        {/* Hamburger Menu (Mobile) */}
        <button className="hamburger-menu" onClick={toggleMenu}>
          ☰
        </button>

        {/* Navigation Links */}
        <ul className={`nav-list ${menuOpen ? "open" : ""}`}>
          {isMobile && (
            <li className="nav-item dark-mode-toggle-container">
              <button onClick={toggleDarkMode} className="dark-mode-toggle">
                {isDarkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
              </button>
            </li>
          )}

          <li className="nav-item">
            <Link to="/" onClick={closeMenu}>Home</Link>
          </li>
          <li className="nav-item">
            <Link to="/topics/contents" onClick={closeMenu}>Topics</Link>
          </li>
          <li className="nav-item">
            <Link to="/forum" onClick={closeMenu}>Forums</Link>
          </li>
          <li className="nav-item">
            <Link to="/blog" onClick={closeMenu}>Blog</Link>
          </li>

          {isAuthenticated ? (
            <>
              <li className="nav-item">
                <Link to="/profile" onClick={closeMenu}>My Journey</Link>
              </li>
              <li className="nav-item">
                <span>Welcome, {user.username}</span>
              </li>
              <li className="nav-item">
                <button onClick={handleLogout} className="logout-button">
                  Logout
                </button>
              </li>
            </>
          ) : (
            <>
              <li className="nav-item">
                <Link to="/login" onClick={closeMenu}>Login</Link>
              </li>
              <li className="nav-item">
                <Link to="/register" onClick={closeMenu}>Register</Link>
              </li>
            </>
          )}

          {/* ✅ Dark Mode Toggle (Desktop Only) */}
          {!isMobile && (
            <li className="nav-item dark-mode-toggle-desktop">
              <button onClick={toggleDarkMode} className="dark-mode-toggle">
                {isDarkMode ? "☀️ Light Mode" : "🌙 Dark Mode"}
              </button>
            </li>
          )}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
